var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.ocorrenciaReturn, function(msg, id) {
        return _c(
          "div",
          { key: id, staticClass: "mb-3" },
          [
            _c("v-mensagem", {
              attrs: {
                mensagem: msg,
                perfil: _vm.perfil,
                tipoReembolso: _vm.ocorrencia.tipo_reembolso
              }
            })
          ],
          1
        )
      }),
      _vm._v(" "),
      _vm.ocorrencia.id
        ? _c(
            "b-row",
            { staticClass: "mt-3 mb-3", attrs: { "align-self": "right" } },
            [
              ["adm", "coord_comercial"].includes(_vm.perfil) &&
              ["SOLUCIONADO", "FECHADO"].includes(_vm.ocorrencia.status)
                ? _c(
                    "b-button",
                    {
                      staticClass: "mr-3",
                      attrs: {
                        size: "sm",
                        variant: "warning",
                        disabled: _vm.loading
                      },
                      on: { click: _vm.reabrirOc }
                    },
                    [
                      _c("i", { staticClass: "fas fa-undo" }),
                      _vm._v("\n      Reabrir Ocorrência\n    ")
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              ["adm", "coord_comercial", "sac"].includes(_vm.perfil) &&
              ["FECHADO", "CANCELADA"].includes(_vm.ocorrencia.status)
                ? _c(
                    "b-button",
                    {
                      attrs: {
                        size: "sm",
                        variant: "danger",
                        disabled: _vm.loading
                      },
                      on: {
                        click: function($event) {
                          return _vm.cancelar()
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fas fa-ban" }),
                      _vm._v("\n      Cancelar Ocorrência\n    ")
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.ocorrencia.status != "NOVO" &&
      ["adm", "coord_comercial", "comercial"].includes(_vm.perfil) &&
      _vm.ocorrencia.notificacoes &&
      _vm.ocorrencia.notificacoes.length > 0
        ? _c("b-card", { staticClass: "mb-3" }, [
            _c("div", [_c("h6", [_vm._v("Notificações")])]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "accordion", attrs: { role: "tablist" } },
              _vm._l(_vm.ocorrencia.notificacoes, function(notificacao, id) {
                return _c(
                  "b-card",
                  { key: id, staticClass: "mb-1", attrs: { "no-body": "" } },
                  [
                    _c(
                      "b-card-header",
                      {
                        staticClass: "p-1",
                        attrs: { "header-tag": "header", role: "tab" }
                      },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: {
                              block: "",
                              size: "sm",
                              variant: "secondary"
                            },
                            on: {
                              click: function($event) {
                                notificacao.visible = !notificacao.visible
                              }
                            }
                          },
                          [_vm._v(_vm._s(notificacao.destinatario))]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-collapse",
                      {
                        attrs: { visible: "", role: "tabpanel" },
                        model: {
                          value: notificacao.visible,
                          callback: function($$v) {
                            _vm.$set(notificacao, "visible", $$v)
                          },
                          expression: "notificacao.visible"
                        }
                      },
                      [
                        _c(
                          "b-card-body",
                          [
                            _c(
                              "b-card-text",
                              [
                                _c("b-row", [
                                  _vm._v(
                                    " Enviado por: " +
                                      _vm._s(notificacao.user.name) +
                                      " "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("b-row", { staticClass: "mt-2" }, [
                                  _vm._v(" Cc: " + _vm._s(notificacao.cc) + " ")
                                ]),
                                _vm._v(" "),
                                _c("b-row", { staticClass: "mt-2" }, [
                                  _vm._v(
                                    "\n                Mensagem: " +
                                      _vm._s(notificacao.mensagem) +
                                      "\n              "
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  { staticClass: "mt-2" },
                                  [
                                    _c("b-col", [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.formatarData(
                                              _vm.mensagem.created_at
                                            )
                                          ) +
                                          "\n                "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("b-col", [
                                      _vm._v(
                                        "\n                  Enviado Anexos: " +
                                          _vm._s(
                                            notificacao.anexo ? "Sim" : "Não"
                                          ) +
                                          "\n                "
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.viewCardMensagem
        ? _c(
            "b-card",
            { class: _vm.tipoMsg },
            [
              _c(
                "b-overlay",
                { attrs: { show: _vm.loading, rounded: "sm" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: { small: "", "label-size": "sm", id: "formulario" }
                    },
                    [
                      !_vm.ocorrencia.id
                        ? _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "6" } },
                                [
                                  _c("label", { attrs: { for: "tipoO" } }, [
                                    _vm._v("Tipo de Ocorrência")
                                  ]),
                                  _vm._v(" "),
                                  _c("b-form-select", {
                                    attrs: {
                                      disabled: _vm.ocorrencia.id > 0,
                                      id: "tipoO",
                                      options: _vm.optionsOc,
                                      size: "sm"
                                    },
                                    on: { change: _vm.produtoClear },
                                    model: {
                                      value: _vm.tipoOcorrencia,
                                      callback: function($$v) {
                                        _vm.tipoOcorrencia = $$v
                                      },
                                      expression: "tipoOcorrencia"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.classeDistribuidor === "G"
                                ? _c(
                                    "b-col",
                                    [
                                      _c("label", { attrs: { for: "" } }, [
                                        _vm._v("Enviar Para:")
                                      ]),
                                      _vm._v(" "),
                                      _c("b-form-select", {
                                        attrs: {
                                          size: "sm",
                                          options: _vm.optionsEnviarPara
                                        },
                                        model: {
                                          value: _vm.enviarPara,
                                          callback: function($$v) {
                                            _vm.enviarPara = $$v
                                          },
                                          expression: "enviarPara"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.ocorrencia.id
                        ? _c(
                            "b-row",
                            { staticClass: "mt-3" },
                            [
                              _c(
                                "b-col",
                                [
                                  _c("label", { attrs: { for: "" } }, [
                                    _vm._v("Lote")
                                  ]),
                                  _vm._v(" "),
                                  _c("b-form-select", {
                                    attrs: {
                                      id: "tipoO",
                                      options: _vm.optionsLote,
                                      size: "sm"
                                    },
                                    on: { change: _vm.produtoClear },
                                    model: {
                                      value: _vm.lote,
                                      callback: function($$v) {
                                        _vm.lote = $$v
                                      },
                                      expression: "lote"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("b-col", { attrs: { cols: "6" } }, [
                                _vm.revendedoras.length > 0
                                  ? _c(
                                      "div",
                                      [
                                        _c("label", { attrs: { for: "" } }, [
                                          _vm._v("Revendedora")
                                        ]),
                                        _vm._v(" "),
                                        _c("b-form-select", {
                                          attrs: {
                                            size: "sm",
                                            options: _vm.revendedoras
                                          },
                                          model: {
                                            value: _vm.revendedora,
                                            callback: function($$v) {
                                              _vm.revendedora = $$v
                                            },
                                            expression: "revendedora"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "mt-3" },
                        [
                          !_vm.ocorrencia.id &&
                          _vm.tipoOcorrencia &&
                          (_vm.tipoOcorrencia < 4 || _vm.tipoOcorrencia == 6) &&
                          _vm.produtosPedido.length > 0
                            ? _c(
                                "b-col",
                                {
                                  staticClass: "text-right",
                                  attrs: { cols: "12" }
                                },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { size: "sm", variant: "primary" },
                                      on: {
                                        click: function($event) {
                                          _vm.modalProdutos = true
                                        }
                                      }
                                    },
                                    [
                                      _c("i", { staticClass: "fas fa-edit" }),
                                      _vm._v(" Editar Produtos\n            ")
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "text-right mr-3",
                              attrs: { cols: "12" }
                            },
                            [
                              _vm.produto && _vm.produto.quantidade
                                ? _c(
                                    "small",
                                    { staticStyle: { color: "red" } },
                                    [
                                      _vm._v(
                                        "Quantidade máxima: " +
                                          _vm._s(_vm.produto.quantidade)
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.ocorrencia.id &&
                      _vm.tipoOcorrencia &&
                      (_vm.tipoOcorrencia < 4 || _vm.tipoOcorrencia == 6)
                        ? _c(
                            "b-row",
                            { staticClass: "mt-3" },
                            [
                              _vm.getProdutosIncluidos.length > 0
                                ? _c(
                                    "b-col",
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "d-flex align-items-center mb-1"
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              "Lote do Produto com Avaria (por produto)"
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("i", {
                                            directives: [
                                              {
                                                name: "b-tooltip",
                                                rawName: "v-b-tooltip.hover",
                                                modifiers: { hover: true }
                                              }
                                            ],
                                            staticClass:
                                              "fas fa-info-circle text-info ml-2",
                                            attrs: {
                                              title:
                                                "Informe o lote de avaria para cada produto(somente numeros). Se houver múltiplos lotes para o mesmo produto, informe na descrição da ocorrencia, separe com vírgula (Ex:codigo: 2222  lote: 888888, 999999, 123456)"
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("b-table", {
                                        attrs: {
                                          items: _vm.getProdutosIncluidos,
                                          fields: _vm.colunas
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "cell(label)",
                                              fn: function(row) {
                                                return [
                                                  _c("small", [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          row.item.codigo +
                                                            " - " +
                                                            row.item.nome
                                                        ) +
                                                        "\n                "
                                                    )
                                                  ])
                                                ]
                                              }
                                            },
                                            {
                                              key: "cell(lote_produto_avaria)",
                                              fn: function(row) {
                                                return [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      type: "text",
                                                      placeholder: "Ex: 999999",
                                                      size: "sm"
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        row.item.lote_produto_avaria = row.item.lote_produto_avaria.replace(
                                                          /[^0-9]/g,
                                                          ""
                                                        )
                                                      },
                                                      change: function($event) {
                                                        row.item.lote_produto_avaria = row
                                                          .item
                                                          .lote_produto_avaria
                                                          ? String(
                                                              row.item
                                                                .lote_produto_avaria
                                                            ).trim()
                                                          : ""
                                                      }
                                                    },
                                                    model: {
                                                      value:
                                                        row.item
                                                          .lote_produto_avaria,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          row.item,
                                                          "lote_produto_avaria",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "row.item.lote_produto_avaria"
                                                    }
                                                  })
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          1836683714
                                        )
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.ocorrencia.id ||
                      _vm.ocorrencia.status == "SOLUCIONADO"
                        ? _c(
                            "b-row",
                            {
                              staticClass: "mt-3 mb-1",
                              attrs: { "align-v": "end" }
                            },
                            [
                              _vm.ocorrencia.id &&
                              _vm.ocorrencia.status != "REABRIR"
                                ? _c(
                                    "b-col",
                                    { staticClass: "col-md-6" },
                                    [
                                      _c("label", { attrs: { for: "" } }, [
                                        _vm._v("Tipo de Mensagem")
                                      ]),
                                      _vm._v(" "),
                                      _c("b-form-select", {
                                        attrs: {
                                          options: _vm.optionsMsg,
                                          size: "sm",
                                          disabled: _vm.loading
                                        },
                                        model: {
                                          value: _vm.tipoMsg,
                                          callback: function($$v) {
                                            _vm.tipoMsg = $$v
                                          },
                                          expression: "tipoMsg"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showAprovaReembolso
                                ? _c(
                                    "b-col",
                                    { staticClass: "col-md-6" },
                                    [
                                      _c("label", { attrs: { for: "" } }, [
                                        _vm._v("Aprovar Reembolso?")
                                      ]),
                                      _vm._v(" "),
                                      _c("b-form-select", {
                                        attrs: {
                                          options: _vm.reembolsoOptions,
                                          size: "sm",
                                          disabled: _vm.loading
                                        },
                                        model: {
                                          value: _vm.reembolso,
                                          callback: function($$v) {
                                            _vm.reembolso = $$v
                                          },
                                          expression: "reembolso"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.tipoMsg == "SOLUCIONAR" &&
                              (_vm.ocorrencia.tipo < 4 ||
                                _vm.ocorrencia.tipo == 6)
                                ? _c(
                                    "b-col",
                                    [
                                      _c("label", { attrs: { for: "" } }, [
                                        _vm._v("Tipo de Reembolso")
                                      ]),
                                      _vm._v(" "),
                                      _c("b-form-select", {
                                        attrs: {
                                          options: _vm.optionsReembolso,
                                          size: "sm",
                                          disabled: _vm.loading
                                        },
                                        model: {
                                          value: _vm.tipoReembolso,
                                          callback: function($$v) {
                                            _vm.tipoReembolso = $$v
                                          },
                                          expression: "tipoReembolso"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.tipoMsg == "SOLUCIONAR" &&
                      _vm.tipoReembolso &&
                      _vm.tipoReembolso == "PRODUTO"
                        ? _c(
                            "div",
                            [
                              _c(
                                "b-row",
                                { staticClass: "mt-3" },
                                [
                                  _c(
                                    "b-col",
                                    { staticClass: "text-right col-md-12" },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            size: "sm",
                                            variant: "success"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.addFaturar = !_vm.addFaturar
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.addFaturar
                                                  ? "Remover Produtos"
                                                  : "Adicionar produtos"
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.ocorrencia.id &&
                              _vm.addFaturar &&
                              _vm.tipoMsg == "SOLUCIONAR"
                                ? _c(
                                    "b-row",
                                    {
                                      staticClass: "mt-3",
                                      attrs: { "align-v": "end" }
                                    },
                                    [
                                      _c(
                                        "b-col",
                                        { staticClass: "col-md-9" },
                                        [
                                          _c("label", { attrs: { for: "" } }, [
                                            _vm._v("Produto")
                                          ]),
                                          _vm._v(" "),
                                          _c("v-select", {
                                            staticClass: "select-produtos",
                                            attrs: {
                                              placeholder: "Código do Produto",
                                              options: _vm.listProdutosReembolso
                                            },
                                            on: {
                                              search: _vm.getProdutosReembolso
                                            },
                                            model: {
                                              value: _vm.produto,
                                              callback: function($$v) {
                                                _vm.produto = $$v
                                              },
                                              expression: "produto"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { staticClass: "col-md-2" },
                                        [
                                          _c("label", { attrs: { for: "" } }, [
                                            _vm._v("Quantidade")
                                          ]),
                                          _vm._v(" "),
                                          _c("b-form-input", {
                                            attrs: {
                                              min: "0",
                                              max: "1000",
                                              type: "number",
                                              size: "sm",
                                              disabled:
                                                !_vm.produto ||
                                                !_vm.produto.disponivel
                                            },
                                            on: {
                                              keyup: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                return _vm.addProduto("faturar")
                                              }
                                            },
                                            model: {
                                              value: _vm.qtdProduto,
                                              callback: function($$v) {
                                                _vm.qtdProduto = $$v
                                              },
                                              expression: "qtdProduto"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { staticClass: "col-md-1" },
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              attrs: {
                                                size: "sm",
                                                variant: "primary",
                                                title: "Adicionar Produto",
                                                disabled:
                                                  !_vm.produto ||
                                                  !_vm.produto.disponivel
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.addProduto(
                                                    "faturar"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fas fa-plus"
                                              })
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _vm.produto
                                    ? _c("b-col", { staticClass: "ml-3" }, [
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.produto.preco) +
                                                " " +
                                                _vm._s(
                                                  _vm.qtdProduto
                                                    ? " x " +
                                                        _vm.qtdProduto +
                                                        " = " +
                                                        parseFloat(
                                                          _vm.produto.preco *
                                                            _vm.qtdProduto
                                                        )
                                                          .toFixed(2)
                                                          .toString()
                                                          .replace(".", ",")
                                                    : ""
                                                )
                                            )
                                          ]
                                        )
                                      ])
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.aFaturar.length > 0
                                ? _c(
                                    "b-row",
                                    { staticClass: "mt-3" },
                                    [
                                      _vm.ocorrencia.id &&
                                      _vm.addFaturar &&
                                      _vm.tipoMsg == "SOLUCIONAR"
                                        ? _c("b-table", {
                                            staticClass: "mt-2",
                                            attrs: {
                                              items: _vm.aFaturar,
                                              fields: _vm.colunas,
                                              hover: "",
                                              "hide-header": ""
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "cell(actions)",
                                                  fn: function(row) {
                                                    return [
                                                      _c(
                                                        "b-button",
                                                        {
                                                          attrs: {
                                                            size: "sm",
                                                            variant: "danger",
                                                            title:
                                                              "Remover Produto"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.removeProduto(
                                                                row.item,
                                                                "faturar"
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fas fa-trash"
                                                          })
                                                        ]
                                                      )
                                                    ]
                                                  }
                                                },
                                                {
                                                  key: "cell(label)",
                                                  fn: function(row) {
                                                    return [
                                                      _c("small", [
                                                        _vm._v(
                                                          "\n                  " +
                                                            _vm._s(
                                                              row.item.codigo +
                                                                " - " +
                                                                row.item.nome
                                                            ) +
                                                            "\n                "
                                                        )
                                                      ])
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              false,
                                              2252247724
                                            )
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "text-right text-danger",
                                      attrs: { cols: "12" }
                                    },
                                    [
                                      _c("small", [
                                        _vm._v(
                                          " Total: " +
                                            _vm._s(_vm.getTotalReembolso) +
                                            " "
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "mt-3 mb-3" },
                        [
                          _c(
                            "b-col",
                            [
                              _c("b-form-textarea", {
                                attrs: {
                                  id: "textarea-rows",
                                  "no-resize": "",
                                  placeholder: !_vm.ocorrencia.id
                                    ? "Por favor, descreva a ocorrência com o máximo de detalhes possíveis!"
                                    : "Mensagem",
                                  rows: "10",
                                  disabled: _vm.loading
                                },
                                model: {
                                  value: _vm.mensagem,
                                  callback: function($$v) {
                                    _vm.mensagem = $$v
                                  },
                                  expression: "mensagem"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { attrs: { "align-h": "center" } },
                        [
                          _c(
                            "b-col",
                            { staticClass: "col-md-4 text-center" },
                            [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("Anexos")
                              ]),
                              _vm._v(" "),
                              _c("b-form-file", {
                                attrs: {
                                  size: "sm",
                                  accept: ".jpg, .jpeg, .png, .gif, .pdf",
                                  "browse-text": "Adicionar",
                                  placeholder: ".jpg, .jpeg, .png, .gif, .pdf",
                                  "drop-placeholder": "Solte o arquivo aqui...",
                                  multiple: ""
                                },
                                model: {
                                  value: _vm.anexos,
                                  callback: function($$v) {
                                    _vm.anexos = $$v
                                  },
                                  expression: "anexos"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-3", attrs: { "align-h": "end" } },
                    [
                      _c(
                        "b-col",
                        { staticClass: "text-right" },
                        [
                          _vm.ocorrencia.tipo || _vm.status == "NOVO"
                            ? _c(
                                "b-button",
                                {
                                  attrs: {
                                    disabled: _vm.loading,
                                    size: "sm",
                                    variant: "success"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.salvar()
                                    }
                                  }
                                },
                                [
                                  _vm.loading
                                    ? _c("b-spinner", {
                                        attrs: {
                                          small: "",
                                          variant: "primary",
                                          label: "Spinning"
                                        }
                                      })
                                    : _c("i", { staticClass: "fas fa-save" }),
                                  _vm._v("\n            Salvar\n          ")
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { size: "xl", title: "Produtos do Pedido" },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary", size: "sm" },
                      on: {
                        click: function($event) {
                          _vm.modalProdutos = false
                        }
                      }
                    },
                    [_vm._v("Fechar")]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.modalProdutos,
            callback: function($$v) {
              _vm.modalProdutos = $$v
            },
            expression: "modalProdutos"
          }
        },
        [
          _c(
            "b-card",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("label", { attrs: { for: "" } }, [_vm._v("Produto")]),
                      _vm._v(" "),
                      _c("b-form-input", {
                        attrs: {
                          id: "filter-input",
                          type: "search",
                          placeholder: "Código"
                        },
                        model: {
                          value: _vm.filterModal,
                          callback: function($$v) {
                            _vm.filterModal = $$v
                          },
                          expression: "filterModal"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-table", {
                        attrs: {
                          striped: "",
                          hover: "",
                          items: _vm.produtosPedido,
                          fields: _vm.fieldsProdutos,
                          small: "",
                          stacked: "md",
                          filter: _vm.filterModal,
                          "filter-included-fields": _vm.filterOn
                        },
                        on: { filtered: _vm.onFiltered },
                        scopedSlots: _vm._u([
                          {
                            key: "cell(nome)",
                            fn: function(row) {
                              return [
                                _c("small", [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        row.item.codigo + " - " + row.item.nome
                                      ) +
                                      "\n              "
                                  )
                                ])
                              ]
                            }
                          },
                          {
                            key: "cell(actions)",
                            fn: function(row) {
                              return [
                                row.item.ocorrencia
                                  ? _c("span", { staticClass: "text-center" }, [
                                      _c("small", [
                                        _c("b", [_vm._v("Ocorrência")]),
                                        _vm._v(" "),
                                        _c("br"),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href:
                                                "/ocorrencia/" +
                                                row.item.ocorrencia,
                                              target: "__blank"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(row.item.ocorrencia) +
                                                " "
                                            )
                                          ]
                                        )
                                      ])
                                    ])
                                  : _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          variant: row.item.incluir
                                            ? "danger"
                                            : "success",
                                          size: "sm"
                                        },
                                        on: {
                                          click: function($event) {
                                            row.item.incluir = !row.item.incluir
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              row.item.incluir
                                                ? "Remover"
                                                : "Incluir"
                                            ) +
                                            "\n              "
                                        )
                                      ]
                                    )
                              ]
                            }
                          },
                          {
                            key: "cell(quantidade)",
                            fn: function(row) {
                              return [
                                !row.item.ocorrencia
                                  ? _c("b-form-input", {
                                      attrs: { size: "sm" },
                                      on: {
                                        change: function($event) {
                                          row.item.quantidade >
                                            row.item.qtdOriginal ||
                                          row.item.quantidade <= 0
                                            ? (row.item.quantidade =
                                                row.item.qtdOriginal)
                                            : row.item.quantidade
                                        }
                                      },
                                      model: {
                                        value: row.item.quantidade,
                                        callback: function($$v) {
                                          _vm.$set(row.item, "quantidade", $$v)
                                        },
                                        expression: "row.item.quantidade"
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("small", { staticStyle: { color: "red" } }, [
                                  _vm._v(
                                    "Qtd. Pedido: " +
                                      _vm._s(row.item.qtdOriginal)
                                  )
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-86d6641e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86d6641e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/ocorrencia/componente/Mensagens.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-86d6641e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/ocorrencia/componente/Mensagens.vue
// module chunks = 2